{
 "name": "",
 "type": "object",
 "class": "g gtc-6 gtr-4",
 "definitions": [
  {
   "name": "customer",
   "type": "fieldOk",
   "class": "gr-2 gc-1-3 ds-caption-medium uppercase color-light c row center-v",
   "format": "{{number}} - {{name}}",
   "fieldOk": "ktostamm.kunde"
  },
  {
   "name": "object",
   "type": "fieldOk",
   "class": "gr-4 gc-1-6 ds-body-1-semibold mt-2 inline-block",
   "format": "{{number}} - {{name}}",
   "fieldOk": "objekt"
  },
  {
   "name": "",
   "type": "string",
   "class": "gr-1 gc-4-6 soft-overline no-wrap c row end center-v flex items-end justify-end",
   "format": "{{from:TIME.DEFAULT}} - {{to:TIME.DEFAULT}}"
  },
  {
   "name": "",
   "type": "string",
   "class": "gr-1 gc-1-3 soft-overline no-wrap c row center-v",
   "format": "{{date:DATE.DEFAULT}}"
  },
  {
   "name": "description",
   "type": "string",
   "class": "gr-3 gc-1-4 ds-body-2 c row mt-1 text-light"
  },
  {
   "name": "icon",
   "class": "gr-3 gc-4-6 c row end flex items-end justify-end",
   "type": "icon",
   "icon": "fas fa-mug-hot",
   "visible": {
    "name": "property",
    "property": "kzpause",
    "rule": {
     "name": "boolean",
     "value": true
    }
   }
  }
 ]
}
